module.exports = __webpack_public_path__ + "img/footer-lg.8043ec3b.svg";